import React from "react";
import Chart from "react-apexcharts";
import { Card, Button, Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import "bootstrap/dist/css/bootstrap.min.css";

const users = [
  {
    name: "Michael Johnson",
    role: "Administration Head",
    time: "09:45 AM",
    data: [6, 7, 5, 6, 7, 5, 0, 0],
    type: "Positive",
  },
  {
    name: "Emily Davis",
    role: "Frontend Developer",
    time: "09:30 AM",
    data: [5, 4, 3, 5, 4, 0, 0, 0],
    type: "Negative",
  },
  {
    name: "Robert Martinez",
    role: "Finance Manager",
    time: "09:25 AM",
    data: [4, 5, 4, 4, 0, 0, 0, 0],
    type: "Positive",
  },
  {
    name: "Megan Walker",
    role: "SEO Analyst",
    time: "09:10 AM",
    data: [3, 3, 4, 0, 0, 0, 0, 0],
    type: "Positive",
  },
];

export default function LateArrivals() {
  return (
    <Card className="arrival-card">
      <Card.Body>

        {/* HEADER */}
        <div className="header">
          <h5>Late Arrivals & Alerts</h5>

          {/* ✅ DROPDOWN */}
          <Dropdown>
            <Dropdown.Toggle className="date-btn-today">
              <FiCalendar /> Today
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item>Daily</Dropdown.Item>
              <Dropdown.Item>Weekly</Dropdown.Item>
              <Dropdown.Item>Monthly</Dropdown.Item>
              <Dropdown.Item>Yearly</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* LIST */}
        {users.map((user, i) => (
          <div className="row-item" key={i}>

            <div className="left">
              <img
                src={`https://i.pravatar.cc/100?img=${i + 10}`}
                alt=""
                className="avatar"
              />
              <div>
                <h6>{user.name}</h6>
                <p>{user.role}</p>
              </div>
            </div>

            <div className="middle">
              Check-in: <strong>{user.time}</strong>
            </div>

            <div className="right">
              <Chart
                options={{
                  chart: {
                    type: "bar",
                    sparkline: { enabled: true },
                    toolbar: { show: false },
                  },

                  plotOptions: {
                    bar: {
                      columnWidth: "30%",
                      borderRadius: 3,
                    },
                  },

                  colors: ["#ff7a2f"],

                  // ✅ DEFAULT TOOLTIP (LIKE YOUR IMAGE)
                  tooltip: {
                    enabled: true,
                    shared: true,
                    intersect: false,
                  },

                  xaxis: {
                    categories: user.data.map((_, i) => i + 1),
                    labels: { show: false },
                  },

                  yaxis: { show: false },
                  grid: { show: false },
                }}

                // ✅ IMPORTANT (NAME FOR TOOLTIP)
                series={[
                  {
                    name: user.type,
                    data: user.data,
                  },
                ]}

                type="bar"
                height={50}
                width={120}
              />
            </div>

          </div>
        ))}
      </Card.Body>

      {/* CSS */}
      <style>{`
        .arrival-card {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
        }

        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }

        .header h5 {
          font-weight: 600;
        }

        .date-btn-today {
          background: #fff;
          border: 1px solid #e5e7eb;
          color: #333;
          font-size: 14px;
          display: flex;
          align-items: center;
          gap: 6px;
        }

/* 🔥 FIX DROPDOWN TOGGLE (no white on hover/click) */
.date-btn-today ,
.date-btn-today :focus,
.date-btn-today :active,
.show > .date-btn-today .dropdown-toggle {
  background-color: #fff !important;
  color: #333 !important;
  border: 1px solid #e5e7eb !important;
  box-shadow: none !important;
}

/* 🔥 FIX DROPDOWN MENU BACKGROUND */
.dropdown-menu {
  background-color: #fff !important;
  border-radius: 10px;
  border: 1px solid #eee;
  overflow: hidden;
}

/* 🔥 HOVER ITEM (ORANGE) */
.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus {
  background-color: #ff7a2f !important;
  color: #fff !important;
}

/* 🔥 REMOVE WHITE FLASH */
.dropdown-item {
  background-color: transparent !important;
}
        .row-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border: 1px solid #eee;
          padding: 14px;
          border-radius: 10px;
          margin-bottom: 12px;
        }

        .left {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .avatar {
          width: 45px;
          height: 45px;
          border-radius: 50%;
        }

        .left h6 {
          margin: 0;
          font-size: 15px;
          font-weight: 600;
        }

        .left p {
          margin: 0;
          font-size: 13px;
          color: #6b7280;
        }

        .middle {
          font-size: 14px;
          color: #555;
        }

        .middle span {
          font-weight: 600;
        }

        .right {
          min-width: 120px;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .row-item {
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;
          }

          .right {
            width: 100%;
          }
        }
      `}</style>
    </Card>
  );
}